module.exports = __webpack_public_path__ + "img/a time when the girl lived.bac2a0ca.png";